import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';

export class CreateShiftAutomationForm {
  public userId: string = '';
  public shiftType: number;

  public rules: { [key: string]: FormValidationFunction[] } = {
    userId: [
      (v: string) => !!v || 'This field is required.',
    ],
    shiftType: [
      (v: number) => !!v || 'This field is required.',
    ],
  };
}
